<template>
    <b-row>
        <b-col cols="12" class="mb-4">
            <b-card no-body border-variant="transparent" bg-variant="transparent" class="glass">
                <div style="height:50px;" v-show="programSeasonParticipantLoading">
                    <pulse-loader
                        :color="'#fff'"
                        :margin="'10px'"
                        :size="15"
                        style="position:absolute;top:50%;left:50%;transform:translate(-50%,-50%)"/>
                </div>

                <b-card-body
                    v-show="!programSeasonParticipantLoading"
                    class="py-2 text-uppercase text-center text-white"
                    style="font-weight: bolder"
                    body-border-variant="transparent"
                    body-bg-variant="transparent"
                >
                    {{ programSeasonParticipant.attributes.participant_full_name }} - {{ programSeasonParticipant.attributes.user_document_number }} - {{ programSeasonParticipant.attributes.program }} - {{ programSeasonParticipant.attributes.season }}
                </b-card-body>
            </b-card>
        </b-col>

        <b-col cols="12" class="mb-4">
            <div class="intranet-nav-content apk-nav-tabs">
                <intranet-nav-content-link-exact :link="{ name: 'Detalles', path: { name: 'employee-participant-details' } }"/>
                <!--  -->
                <intranet-nav-content-link :link="{ name: 'Pagos', path: { name: 'employee-participant-payments-vouchers' } }"/>
                <intranet-nav-content-link :link="{ name: 'Ficha', path: { name: 'employee-participant-ficha' } }"/>
                <intranet-nav-content-link :link="{ name: 'Entrevistas', path: { name: 'employee-participant-interviews' } }"/>
                <intranet-nav-content-link :link="{ name: 'Contratos', path: { name: 'employee-participant-contracts' } }"/>
                <intranet-nav-content-link :link="{ name: 'Documentos', path: { name: 'employee-participant-documents' } }"/>
                <!--  -->
                <intranet-nav-content-link :link="{ name: 'Capacitaciones', path: { name: 'employee-participant-capacitations' } }"/>
                <intranet-nav-content-link :link="{ name: 'Charlas', path: { name: 'employee-participant-talks' } }"/>
                <intranet-nav-content-link :link="{ name: 'Visado', path: { name: 'employee-participant-visa' } }"/>
                <intranet-nav-content-link :link="{ name: 'Postulaciones', path: { name: 'employee-participants-attempts-list' } }"/>
            </div>
        </b-col>

        <b-col>
            <slide-y-down-transition :duration="350" origin="center top" mode="out-in">
                <router-view></router-view>
            </slide-y-down-transition>
        </b-col>
    </b-row>

</template>

<script>
import { getProgramSeasonParticipant } from '@/api/ProgramSeasonParticipant/ProgramSeasonParticipant.js'
//
import IntranetNavContentLink from '@/layout/NavContent/IntranetNavContentLink';
import IntranetNavContentLinkExact from '@/layout/NavContent/IntranetNavContentLinkExact';
import { SlideYDownTransition  } from 'vue2-transitions';
//import { PulseLoader } from '@saeris/vue-spinners'

export default {
    name: 'Participant',
    components: { 
        IntranetNavContentLink,
        IntranetNavContentLinkExact,
        SlideYDownTransition,
        // PulseLoader
    },
    data: () => ({
        programSeasonParticipant: {
            attributes: {}
        },
        programSeasonParticipantLoading: false
    }),
    created () {
        this.getData()
    },
    methods: {
        getData () {
            this.programSeasonParticipantLoading = true

            getProgramSeasonParticipant(this.$route.params.IdProgramSeasonParticipant)
                .then(({data}) => {
                    this.programSeasonParticipant = data.data
                })
                .catch(err => {
                    console.log('getProgramSeasonParticipant err', err);
                })
                .finally(() => {
                    this.programSeasonParticipantLoading = false
                    console.log('request getProgramSeasonParticipant end');
                })
        }
    }
};
</script>

<style scoped>
.glass {
    background-color: rgba(255, 255, 255, .3) !important;
    box-shadow: 0 3px 6px rgba(0, 0, 0, 0.1) !important;
    backdrop-filter: blur(5px) !important;
    color: white !important;
    border:1px solid rgba(255, 255, 255, 0.9) !important;
    overflow: hidden;
}
.intranet-nav-content {
    display: flex;
    align-items: center;
    overflow-x:auto;
    white-space:nowrap;
}
</style>